import { fetchClient } from '../../Utils/helpers';
import {
  CREATE_CUSTOMER,
  CUSTOMER_ITEMS,
  CUSTOMER_MARKET,
  CUSTOMER_REQUESTS,
  CUSTOMER_SUBSCRIPTIONS,
  CUSTOMER_WALLET,
  GET_CUSTOMER,
  GET_CUSTOMER_DETAILS,
} from '../actionTypes';

export function getCustomers({
  page = 1, limit = 10, sort = 'Newest', type = '', keyword = '',
}) {
  return {
    type: GET_CUSTOMER,
    payload: fetchClient({
      method: 'GET',
      url: `/admin/user?page=${page}&limit=${limit}&sort=${sort}&customer_type=${type}&keyword=${keyword}`,
    }),
  };
}

export function createCustomer(data) {
  return {
    type: CREATE_CUSTOMER,
    payload: fetchClient({
      method: 'POST',
      url: '/admin',
      data,
    }),
  };
}

export function getCustomerDetails(id) {
  return {
    type: GET_CUSTOMER_DETAILS,
    payload: fetchClient({
      method: 'GET',
      url: `/admin/user/${id}`,
    }),
  };
}

export function getCustomerItems(id, { keyword = '', limit = 10, page = 1 }) {
  return {
    type: CUSTOMER_ITEMS,
    payload: fetchClient({
      method: 'GET',
      url: `/admin/user/${id}/item-storage?page=${page}&limit=${limit}&keyword=${keyword}`,
    }).then((res) => res.data),
  };
}

export function getCustomerRequests(id, { keyword = '', limit = 10, page = 1 }) {
  return {
    type: CUSTOMER_REQUESTS,
    payload: fetchClient({
      method: 'GET',
      url: `/admin/user/${id}/user-request?page=${page}&limit=${limit}&keyword=${keyword}`,
    }).then((res) => res.data),
  };
}

export function getCustomerSubs(id, { keyword = '', limit = 10, page = 1 }) {
  return {
    type: CUSTOMER_SUBSCRIPTIONS,
    payload: fetchClient({
      method: 'GET',
      url: `/admin/user/${id}/subscription?page=${page}&limit=${limit}&keyword=${keyword}`,
    }).then((res) => res.data),
  };
}

export function getCustomerWallet(id, { keyword = '', limit = 10, page = 1 }) {
  return {
    type: CUSTOMER_WALLET,
    payload: fetchClient({
      method: 'GET',
      url: `/admin/user/${id}/wallet?page=${page}&limit=${limit}&keyword=${keyword}`,
    }).then((res) => res.data),
  };
}

export function getCustomerMarket(id, { keyword = '', limit = 10, page = 1 }) {
  return {
    type: CUSTOMER_MARKET,
    payload: fetchClient({
      method: 'GET',
      url: `/admin/user/${id}/market-item?page=${page}&limit=${limit}&keyword=${keyword}`,
    }).then((res) => res.data),
  };
}
